import templateUrl from 'emun.salesrep/show-hourly-appointments.htm'
import salesrepConfig from 'emun.salesrep/salesrep.config'

class ShowHourlyAppointmentsController {
    constructor($window, $rootScope, retailerPrompt, createAutoQuery) { 
        let $ctrl = this;
        var context = $ctrl.context || 'rep';

		$ctrl.activityType = "Show Appointment";
		$ctrl.year = $ctrl.market.year; //new Date().getFullYear();
		$ctrl.numAppointmentsGoal = 0;
		$ctrl.dollarAmountGoal = 0;

        this.activities = {
            total: 0,
            count: 0
        };

		var repFilter = "";
        if (context != 'executive') {
            var filterType = "SalesRep";
            if (context == 'ManagerId') {
                filterType = 'ManagerId';
            }
            repFilter = "&" + filterType + "=" + $ctrl.rep.id;
        }

        var filterType = "username";
        var repFilter = "";
        if (context != 'executive') {
            if (context == 'ManagerId') {
                filterType = 'ManagerId';
            }
            repFilter = "&" + filterType + "=" + $ctrl.rep.id;
        }
		$ctrl.chartData = [];
		$ctrl.chartLabels = ["7:00 am", "8:00 am", "9:00 am", "10:00 am", "11:00 am", "12:00 pm", "1:00 pm", "2:00 pm", "3:00 pm", "4:00 pm", "5:00 pm", "6:00 pm", "7:00 pm", "8:00 pm", "9:00 pm", "10:00 pm"];
		$ctrl.hours = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22];
		$ctrl.appointments = [0, 0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
		$ctrl.chartSeries = ['Appointments'];
		$ctrl.days = [];
		$ctrl.day = "";
		$ctrl.offset = 0;
		if ($ctrl.market.showCode.toUpperCase().indexOf("ATL") != -1) {
			$ctrl.offset = 5;
		} else if ($ctrl.market.showCode.toUpperCase().indexOf("DAL") != -1) {
			$ctrl.offset = 6;
		} else if ($ctrl.market.showCode.toUpperCase().indexOf("LAS") != -1) {
			$ctrl.offset = 8;
		}
		$ctrl.loadChartData = function () {
			$ctrl.chartData = [];
			$ctrl.appointments = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
			$ctrl.activitiesCount.results.forEach(function (total) {
//				if (moment.utc(total.fullDate).format("MM/DD/YYYY") == $ctrl.day.date) {
				if (moment.utc(total.showDay).format("MM/DD/YYYY") == $ctrl.day.date) {
					$ctrl.hours.forEach(function (hour, index) {
						var showHour = moment.utc(total.fullDate).format("h");
						if (hour == (total.showHour - $ctrl.offset)) {
							$ctrl.appointments[index] = total.appointments;
						}
					});
				}
			});

			$ctrl.chartData.push($ctrl.appointments);
			$ctrl.chartLoaded = true;
		}

		$ctrl.daysQuery = createAutoQuery({
			url: 'QueryShowAppointmentsByDay.json?showCode=' + $ctrl.market.showCode + '&dateRange=calendar&Sum=Appointments&groupBy=ShowCode,ShowDay&orderBy=ShowCode,ShowDay',
			autoLoad: true,
			pageSize: 1000,
			onLoaded: function (args) {
				$ctrl.days = [];
				args.results.forEach(function (total) {
					var day = {
						"date": moment.utc(total.showDay).format("MM/DD/YYYY"),
						"title": moment.utc(total.showDay).format("ddd MM/DD")
						//"date": moment.utc(total.fullDate).format("MM/DD/YYYY"),
						//"title": moment.utc(total.fullDate).format("ddd MM/DD")
					};
					$ctrl.days.push(day);
					if (moment.utc().format("MM/DD/YYYY") == moment.utc(total.showDay).format("MM/DD/YYYY")) {
//					if (moment.utc().format("MM/DD/YYYY") == moment.utc(total.fullDate).format("MM/DD/YYYY")) {
						$ctrl.day = day;
					}
				});
				if ($ctrl.day == "") {
					$ctrl.day = $ctrl.days[0];
				}
				$ctrl.activitiesCount = createAutoQuery({
					url: 'QueryShowAppointmentsByDay.json?showCode=' + $ctrl.market.showCode + '&dateRange=calendar&Sum=Appointments&groupBy=ShowCode,ShowDay,ShowHour&orderBy=ShowCode,ShowDay,ShowHour',
					autoLoad: true,
					pageSize: 1000,
					onLoaded: function (args) {
						$ctrl.loadChartData();
					}
				});
			}
		});

		var gfilterType = "SalesRepID";
        var gfilter = "";
        if (context != 'executive') {
            if (context == 'ManagerId') {
                gfilterType = 'ManagerId';
            }
			gfilter = gfilterType + "=" + $ctrl.rep.id;
        }

		$ctrl.chartColors = ['#DBDBDB'];


		this.chartOptions = {
			maintainAspectRatio: false,
			legend: {
                display: false,
                labels: {
                    boxWidth: 5,
                    fontSize: 10
                }
            },
            elements: {
                rectangle: {
                    borderWidth: 1
                }
            },
			scales: {
				yAxes: [{
					display: true,
					ticks: {
					}
				}]
			},
			tooltips: {
				enabled: true,
			},
		}


	}
	refresh() {
		let $ctrl = this;
		return $ctrl.loadChartData();
	}
}

let ShowHourlyAppointments = {
    bindings: {
        rep: '<',
		context: '@',
		showcode: '@',
		market: '<'
    },
	controller: ShowHourlyAppointmentsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default ShowHourlyAppointments